import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { MaritalEffects, maritalReducer } from './store';

@NgModule({
  imports: [EffectsModule.forFeature([MaritalEffects]), StoreModule.forFeature(`marital`, maritalReducer)]
})
export class MaritalStateModule {}
